module.exports = __webpack_public_path__ + "media/images/xpass/markers/active-selected/clubpilates-ed5d6835c150f49e06b2107cc3311020.png";